module.exports = __webpack_public_path__ + "static/img/top04.d0454e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TW/img/top04.png
// module id = Rppr
// module chunks = 1